import { useContext } from 'react';
import { AppLoaderContext } from '../providers/AppLoaderProvider';
function useAppLoader() {
  return useContext(AppLoaderContext);
}
export default useAppLoader;